import { cn } from '@/lib/utils'

/**
 * Full-viewport scrim that centers its panel — the shared shell for the closet's
 * static centered modals (Save Outfit, Add From URL). Purely presentational:
 * pass the modal panel as children. The animated backdrop (DeleteConfirmModal)
 * and vaul drawers use their own shells, so they intentionally don't go
 * through here.
 */
export function ModalScrim({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className={cn(
        'fixed inset-0 z-[10000] flex items-center justify-center bg-neutral-950/50',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}
